"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CategorizedSearch = void 0;
const react_1 = __importStar(require("react"));
const public_1 = require("../../common/public");
const Search_1 = require("../Search");
const helpers_1 = require("../../helpers");
const searchCategoryAddon_1 = require("./addons/searchCategoryAddon");
const CategorizedSearch_styles_1 = require("./CategorizedSearch.styles");
exports.CategorizedSearch = (0, helpers_1.createUIElement)('CategorizedSearch', function (_a, ref) {
    var { className, termValue = '', categoryValue, onTermChange, onCategoryChange, onSearch, categories, categorySize = public_1.CONTROL_SIZE.xs, size = public_1.CONTROL_SIZE.l, mode, placeholder, maxLength, performed, onClear, hasSearchButton, disabled, hasEnterKeyStopPropagation = true, searchDebounceTimeInMs, onFocus, onBlur, onMouseEnter, onMouseLeave, onKeyDown, onKeyUp, onKeyPress, style, ['data-selector-id']: dataSelectorId } = _a, rest = __rest(_a, ["className", "termValue", "categoryValue", "onTermChange", "onCategoryChange", "onSearch", "categories", "categorySize", "size", "mode", "placeholder", "maxLength", "performed", "onClear", "hasSearchButton", "disabled", "hasEnterKeyStopPropagation", "searchDebounceTimeInMs", "onFocus", "onBlur", "onMouseEnter", "onMouseLeave", "onKeyDown", "onKeyUp", "onKeyPress", "style", 'data-selector-id']);
    const termState = (0, helpers_1.useStateValue)(termValue, [termValue], {
        onChange: (value) => onTermChange === null || onTermChange === void 0 ? void 0 : onTermChange(value || '')
    });
    const categoryState = (0, helpers_1.useStateValue)(categoryValue, [categoryValue], {
        onChange: (value) => onCategoryChange === null || onCategoryChange === void 0 ? void 0 : onCategoryChange(value)
    });
    const handleOnSearch = (0, react_1.useCallback)(() => {
        onSearch === null || onSearch === void 0 ? void 0 : onSearch({
            term: termState.getValue(),
            category: categoryState.getValue()
        });
    }, [categoryState, onSearch, termState]);
    const searchCategoryAddonOnChange = (0, react_1.useCallback)((nextValue) => {
        categoryState.setValue(nextValue);
        if (mode === Search_1.SEARCH_MODE.automatic) {
            handleOnSearch();
        }
    }, [categoryState, handleOnSearch, mode]);
    const searchCategoryAddonProps = (0, react_1.useMemo)(() => {
        return {
            value: categoryState.getValue(),
            onChange: searchCategoryAddonOnChange,
            options: categories,
            size: categorySize
        };
    }, [categories, categorySize, categoryState, searchCategoryAddonOnChange]);
    return (react_1.default.createElement(CategorizedSearch_styles_1.StyledCategorizedSearch, Object.assign({}, rest, { ref: ref, style: style, "data-selector-id": dataSelectorId, size: size, value: termState.getValue(), onChange: termState.setValue, renderRightAddon: (0, searchCategoryAddon_1.searchCategoryAddon)(searchCategoryAddonProps), onSearch: handleOnSearch, mode: mode, placeholder: placeholder, maxLength: maxLength, performed: performed, onClear: onClear, hasSearchButton: hasSearchButton, disabled: disabled, hasEnterKeyStopPropagation: hasEnterKeyStopPropagation, searchDebounceTimeInMs: searchDebounceTimeInMs, onFocus: onFocus, onBlur: onBlur, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, className: (0, helpers_1.cn)('vm-CategorizedSearch', className) })));
});
//# sourceMappingURL=CategorizedSearch.js.map